export default class LogoutDomService {
    constructor() {
        this.button = document.querySelector('[data-action="logout"]');
    }

    /**
     * @return {string|*}
     */
    getToken() {
        return this.button.querySelector('[name="_token"]').value;
    }

    /**
     * @return {string}
     */
    getEndpoint() {
        return this.button.dataset.endpoint;
    }
}
